import React, { useMemo } from 'react';
import { Box, CircularProgress, TablePagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useConfirm } from 'material-ui-confirm';
import ControlledTable from '../../../shared/ui/ControlledTable/ControlledTable';
import { alertsDisplayedCells, alertsHeadCells } from './constants/table';
import { prepareRows, sortByDateAndId } from './utils';

// Отображает панель "Пользователи"
function PaymentInfoTableWidget({
  payments,
  deletePaymentResourceParams,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  loading,
}) {
  const navigate = useNavigate();
  const confirm = useConfirm();

  const rows = useMemo(() => prepareRows(payments), [payments]);

  return !loading ? (
    <>
      <ControlledTable
        rows={sortByDateAndId(rows)}
        headCells={alertsHeadCells}
        displayedCells={alertsDisplayedCells}
        countRowsPerPage={rowsPerPage}
        selected={[]}
        controls
        setSelected={() => {}}
        onEdit={(e) => navigate(`edit/${e.compPaymentId}`)}
        onDelete={(row) => {
          confirm({
            title: 'Удаление',
            confirmationText: 'Да',
            cancellationText: 'Отмена',
            description: `Вы действительно хотите удалить платеж компании «${row?.companyName}» на сумму «${row?.sum}» ?`,
          })
            .then(() => {
              deletePaymentResourceParams({ id: row.compPaymentId });
            })
            .catch(() => {});
        }}
      />
      <TablePagination
        rowsPerPageOptions={[10, 15, 30]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '80px' }}>
      <CircularProgress />
    </Box>
  );
}

PaymentInfoTableWidget.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape()),
  deletePaymentResourceParams: PropTypes.func,
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

PaymentInfoTableWidget.defaultProps = {
  payments: [],
  deletePaymentResourceParams: null,
};

export default PaymentInfoTableWidget;
